import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "@/lib/api";
import { Megaphone } from "lucide-react";

/** Badge in sidebar with unread announcements count. Polls every 60s. */
export default function AnnouncementBell({ to = "/communication" }) {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const fetch = () => api.get("/me/announcements/unread-count").then((r) => setCount(r.data.count || 0)).catch(() => {});
    fetch();
    const t = setInterval(fetch, 60000);
    return () => clearInterval(t);
  }, []);

  if (count === 0) return null;
  return (
    <Link to={to} data-testid="announcement-bell"
      className="relative inline-flex items-center justify-center h-8 w-8 rounded-md bg-emerald-50 border border-emerald-200 hover:bg-emerald-100 transition-colors">
      <Megaphone className="h-4 w-4 text-emerald-700" />
      <span className="absolute -top-1.5 -right-1.5 h-4 min-w-4 px-1 rounded-full bg-red-500 text-white text-[10px] font-bold flex items-center justify-center">
        {count > 9 ? "9+" : count}
      </span>
    </Link>
  );
}
